import Axios from 'axios';
import EZAxios from '@/ezaxios';

export default {
  register(data) {
    return EZAxios.post(`signup`, data);
  },
  verifyPassword(data) {
    data.access_token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return EZAxios.post(`verify-password`, data);
  },
  saveStore(data) {
    data.access_token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return EZAxios.post('save-customer-stores', data);
  },
  getDetails() {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return EZAxios.get(`get-customer-details?access_token=${token}`);
  },
  saveName(data) {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return EZAxios.post(`customer/name?access_token=${token}`, data);
  },
  saveEmail(data) {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return EZAxios.post(`customer/email?access_token=${token}`, data);
  },
  changePassword(data) {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return EZAxios.post(`customer/password?access_token=${token}`, data);
  },
  getCards() {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return EZAxios.get(`customer-cards?access_token=${token}`);
  },
  addCard(newSource) {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return EZAxios.post(`customer-cards/add?access_token=${token}`, { newSource });
  },
  removeCard(source) {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return EZAxios.post(`customer-cards/delete?access_token=${token}`, { source });
  },
  setMarketingEmails(data) {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return EZAxios.post(`customer/set-marketing?access_token=${token}`, data);
  },
  getStoreDistance(zipcode) {
    return EZAxios.get(`store-distance/${zipcode}`);
  }
};
